module.exports = __webpack_public_path__ + "static/media/sospiroopera.1f3f3ccf.png";